import { render, staticRenderFns } from "./menuBarManage.vue?vue&type=template&id=161f22b0&scoped=true"
import script from "./menuBarManage.vue?vue&type=script&lang=js"
export * from "./menuBarManage.vue?vue&type=script&lang=js"
import style0 from "./menuBarManage.vue?vue&type=style&index=0&id=161f22b0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161f22b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('161f22b0')) {
      api.createRecord('161f22b0', component.options)
    } else {
      api.reload('161f22b0', component.options)
    }
    module.hot.accept("./menuBarManage.vue?vue&type=template&id=161f22b0&scoped=true", function () {
      api.rerender('161f22b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/applet/setting/companyapp/modules/menuBarManage.vue"
export default component.exports